<template>
  <div id="main-listado-reporte-consulta">
    <template
      v-if="!$vuetify.breakpoint.mobile">
      <desktop
        :listado="listado">
      </desktop>
    </template>
    <template
      v-else>
      <desktop
        :listado="listado">
      </desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';

export default {
  name: 'MainListadoReporteConsulta',
  components: {
    Desktop,
  },
  props: {
    listado: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
